import {
	UPDATE_VIEWPORT,
	UPDATE_LOGIN_STATUS,
} from '../types/global';

import { updateObject } from '../utility';

const serverState = JSON.parse(document.getElementById('server-state').innerHTML);

const initialState = {
	viewport: null,
	userLoggedIn: serverState.initialState.userLoggedIn || false,
};

const updateViewport = (state, action) => {
	return updateObject(state, {
		viewport: action.viewport,
	});
};

const updateUserLogin = (state, action) => {
	return updateObject(state, {
		userLoggedIn: action.loggedIn,
	});
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case UPDATE_VIEWPORT:
			return updateViewport(state, action);
		case UPDATE_LOGIN_STATUS:
			return updateUserLogin(state, action);
		default:
			return state;
	}
};

export default reducer;
